import { render, staticRenderFns } from "./contractCodePattern.vue?vue&type=template&id=23600d56&scoped=true"
import script from "./contractCodePattern.vue?vue&type=script&lang=js"
export * from "./contractCodePattern.vue?vue&type=script&lang=js"
import style0 from "./contractCodePattern.vue?vue&type=style&index=0&id=23600d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23600d56",
  null
  
)

export default component.exports